import React, { useEffect, useState } from 'react'
import { fireDir } from '../firebase'
import { log } from '../utilities/logger'


export type MLImage = {
    catName: string[]
    url: string
    id: string
    urlThumbnail: string
    isFirebase: boolean
    scaleFactor?: number
}

const useMediaLibrary = (args: { userId: string, auth: number }) => {
    const [MLImages, setMLImages] = useState([] as MLImage[])
    const [inProgress, setInProgress] = useState(false);

    let {userId, auth} = args
    log({userId, auth}, 'DATA firebase')

    useEffect(() => {
        if (userId && auth === 1) {
            setInProgress(true)
            const mlImages: MLImage[] = []
            const tenantRef = fireDir.doc(userId)
            const mlRootRef = tenantRef.collection("Media")
            mlRootRef
                .get()
                .then(mlRootSnap => {
                    let counter = 0
                    for (const mldRef of mlRootSnap.docs) {
                        const mlSourceRef = mlRootRef.doc(mldRef.id)
                        const mlImagesRef = mlSourceRef.collection("Images").orderBy("Name") //sort
                        mlImagesRef
                            .get()
                            .then(mlImagesSnap => {
                                for (const mlImageRef of mlImagesSnap.docs) {
                                    const mlImage = mlImageRef.data()
                                    log({mlImageId: mlImageRef.id}, 'DATA firebase')
                                    if (mlImage.ThumbURL && mlImage.FullSizeURL) {

                                        let imageTile:MLImage = {
                                            catName: mlImage.Categories||[],
                                            id: mlImageRef.id||mlImage.SourceID||counter++,
                                            url: mlImage.FullSizeURL,
                                            urlThumbnail: mlImage.ThumbURL||mlImage.FullSizeURL,
                                            isFirebase: true,
                                            scaleFactor: mlImage.ScaleFactor
                                        }

                                        mlImages.push(imageTile)
                                    }
                                }
                                setMLImages(mlImages)
                            })
                            .catch(err => {
                                console.error("Error getting MediaLibrary(Images)", err)
                            }).finally(()=>{
                                setInProgress(false)
                            })
                    }
                })
                .catch(err => {
                    console.error("Error getting MediaLibrary(root)", err);
                    setInProgress(false)
                })
        }
    }, [userId, auth])

    return {firebaseImages: MLImages, inProgress}
}
export default useMediaLibrary